<template>
  <PopupBox
    :disable="disable"
    class="product-filter-wrapper"
    :popup-styles="{ top: 3 }"
    :placement="isDesktop ? 'bottom-end' : 'bottom-start'"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <h2 :class="clsx('product-filter', { 'product-filter--active': hasActiveFilters, 'product-filter--disabled': disable })">
        <slot />
        <PopupToggler :is-open="popupVisible" :color="calculateTogglerColor" class="ml-2" />
      </h2>
    </template>
    <template>
      <div class="product-filter-content">
        <PopupMenuList
          :items="items"
          :selected-item="selectedItem"
          :checkbox-style="checkboxStyle"
        />
      </div>
    </template>
  </PopupBox>
</template>

<script>
import { clsx } from 'clsx';
import { mapGetters } from 'vuex';
import { PopupBox, PopupMenuList, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
      default: () => {},
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  mixins: [ popupToggle ],
  components: { PopupBox, PopupToggler, PopupMenuList },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
    hasActiveFilters() {
      if (!this.selectedItem?.id) return false;

      const correspondingItem = this.items.find(item => item.id === this.selectedItem.id);
      return correspondingItem?.options?.activeFilter !== false;
    },
    calculateTogglerColor() {
      if (this.disable) {
        return '#6B7280';
      }

      return this.hasActiveFilters ? '#FB923C' : '#09090B';
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.product-filter {
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  &-wrapper {
    display: inline-block;
  }

  &--active {
    color: #FB923C;
  }

  &--disabled {
    cursor: not-allowed;
    color: #6B7280;
  }
}
</style>
